import React from 'react'

const RoundRightIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0C3.13078 0 0 3.13111 0 7C0 10.8692 3.13111 14 7 14C10.8692 14 14 10.8689 14 7C14 3.13078 10.8689 0 7 0ZM7 13.0667C3.65485 13.0667 0.933324 10.3452 0.933324 7C0.933324 3.65482 3.65485 0.933324 7 0.933324C10.3452 0.933324 13.0667 3.65485 13.0667 7C13.0667 10.3452 10.3452 13.0667 7 13.0667Z" fill="black" />
            <path d="M10.7058 4.42831C10.5236 4.24606 10.2281 4.24606 10.0459 4.42831L5.89134 8.58284L3.95486 6.64638C3.77261 6.46413 3.47711 6.46413 3.29489 6.64638C3.11264 6.82863 3.11264 7.1241 3.29489 7.30635L5.56133 9.57279C5.74355 9.75501 6.03913 9.75496 6.2213 9.57279L10.7058 5.08825C10.8881 4.90601 10.8881 4.61056 10.7058 4.42831Z" fill="black" />
        </svg>
    )
}

export default RoundRightIcon